import moment from "moment";

import { MomentFormat } from "@/shared/constants/enums";

export function getDate(date: Date, format: MomentFormat | string): string {
  return moment(date).format(format);
}
